export default "__VITE_ASSET__BjLgP956__"